var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useToggle } from './useToggle';
/**
 * # Toggle
 *
 * @description [vercel design toggle](https://vercel.com/design/toggle)
 *
 * 토글 컴포넌트입니다. 해당 컴포넌트로 토글을 나타냅니다.
 *
 * @param {ToggleProps} {@link ToggleProps} toggle 요소
 *
 * @example ```tsx
 * const [state, setState] = useState(false)
 *
 * <Toggle size="small" toggle={state} onChange={setState} />
 * ```
 */
export var Toggle = function (props) {
    var _a = useToggle(props), _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.color, color = _c === void 0 ? 'blue' : _c, onChange = _a.onChange, otherProps = __rest(_a, ["size", "color", "onChange"]);
    return (<Label>
      <Input type='checkbox' checked={otherProps.toggle} onChange={function () { return onChange(!otherProps.toggle); }} {...otherProps}/>
      <Wrapper size={size} {...otherProps} color={color}>
        <Circle size={size} {...otherProps} color={color}/>
      </Wrapper>
    </Label>);
};
var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  position: relative;\n  vertical-align: middle;\n  white-space: nowrap;\n  user-select: none;\n"], ["\n  display: inline-flex;\n  position: relative;\n  vertical-align: middle;\n  white-space: nowrap;\n  user-select: none;\n"])));
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n  opacity: 0;\n  outline: none;\n"], ["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n  opacity: 0;\n  outline: none;\n"])));
var Wrapper = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, size = _a.size, toggle = _a.toggle, disabled = _a.disabled, color = _a.color;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n    transition: background 0.15s cubic-bezier(0, 0, 0.2, 1);\n    background: ", ";\n    border: 1px solid\n      ", ";\n    border-radius: 14px;\n    cursor: pointer;\n    position: relative;\n    box-sizing: border-box;\n\n    ", "\n  "], ["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n    transition: background 0.15s cubic-bezier(0, 0, 0.2, 1);\n    background: ", ";\n    border: 1px solid\n      ", ";\n    border-radius: 14px;\n    cursor: pointer;\n    position: relative;\n    box-sizing: border-box;\n\n    ", "\n  "])), sizeMapper[size].wrap[0], sizeMapper[size].wrap[1], toggle
        ? color === 'blue'
            ? theme.colors.SUCCESS.DEFAULT
            : theme.colors.HIGHLIGHT.ORANGE
        : theme.colors.PRIMARY.ACCENT_2, toggle
        ? color === 'blue'
            ? theme.colors.SUCCESS.DEFAULT
            : theme.colors.HIGHLIGHT.ORANGE
        : theme.colors.PRIMARY.ACCENT_2, disabled && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: ", ";\n      border-color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background: ", ";\n      border-color: ", ";\n      cursor: not-allowed;\n    "])), theme.colors.PRIMARY.ACCENT_1, theme.colors.PRIMARY.ACCENT_2));
});
var Circle = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, size = _a.size, toggle = _a.toggle, disabled = _a.disabled;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 50%;\n    width: ", "px;\n    height: ", "px;\n    transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1);\n    transform: translate(", "px, -50%);\n    background: ", ";\n    cursor: pointer;\n    border-radius: 50%;\n    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 20%), 0 1px 3px 0 rgb(0 0 0 / 10%);\n    border: 1px solid transparent;\n\n    ", "\n  "], ["\n    position: absolute;\n    left: 0;\n    top: 50%;\n    width: ", "px;\n    height: ", "px;\n    transition: transform 0.15s cubic-bezier(0, 0, 0.2, 1);\n    transform: translate(", "px, -50%);\n    background: ", ";\n    cursor: pointer;\n    border-radius: 50%;\n    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 20%), 0 1px 3px 0 rgb(0 0 0 / 10%);\n    border: 1px solid transparent;\n\n    ", "\n  "])), sizeMapper[size].circle[0], sizeMapper[size].circle[1], toggle ? sizeMapper[size].pos[1] : sizeMapper[size].pos[0], theme.colors.PRIMARY.BACKGROUND, disabled && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background: ", ";\n      cursor: not-allowed;\n    "], ["\n      background: ", ";\n      cursor: not-allowed;\n    "])), theme.colors.PRIMARY.ACCENT_2));
});
var sizeMapper = {
    small: {
        wrap: [28, 14],
        circle: [12, 12],
        pos: [1, 15]
    },
    medium: {
        wrap: [34, 18],
        circle: [16, 16],
        pos: [1, 17]
    },
    large: {
        wrap: [40, 24],
        circle: [22, 22],
        pos: [1, 17]
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=index.jsx.map